import React from 'react';

function formatNumber(value) {
  if (value == null) return '—';
  if (typeof value !== 'number') return String(value);
  if (Math.abs(value) >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (Math.abs(value) >= 10_000) return `${(value / 1000).toFixed(1)}k`;
  return value.toLocaleString();
}

const StatCard = ({ label, value, format = 'number', delta, accent = 'canopy' }) => {
  const accentColors = {
    canopy: 'text-canopy bg-canopy/10',
    meadow: 'text-meadow-700 bg-meadow/10',
    sunbeam: 'text-amber-700 bg-sunbeam/20',
    blush: 'text-blush-700 bg-blush/15',
  };

  const rendered =
    format === 'currency' && typeof value === 'number'
      ? `$${formatNumber(value)}`
      : format === 'percent' && typeof value === 'number'
        ? `${Math.round(value * 100)}%`
        : formatNumber(value);

  const deltaRendered = typeof delta === 'number' && !Number.isNaN(delta) ? delta : null;
  const deltaPositive = deltaRendered != null && deltaRendered > 0;
  const deltaNegative = deltaRendered != null && deltaRendered < 0;
  const deltaColor = deltaPositive
    ? 'text-meadow-700'
    : deltaNegative
      ? 'text-blush-700'
      : 'text-ink-400';

  return (
    <div className="card p-5 flex flex-col gap-2 min-w-0">
      <div className="flex items-center justify-between gap-3">
        <p
          className="text-xs font-semibold uppercase tracking-wide text-ink-400 truncate cursor-help"
          title={label}
        >
          {label}
        </p>
        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${accentColors[accent] || accentColors.canopy}`}>
          today
        </span>
      </div>
      <p className="font-display text-3xl font-semibold text-ink-900 leading-none">
        {rendered}
      </p>
      {deltaRendered != null && (
        <p className={`text-xs font-medium ${deltaColor}`}>
          {deltaPositive ? '↑' : deltaNegative ? '↓' : '•'} {Math.abs(deltaRendered).toLocaleString()} vs yesterday
        </p>
      )}
    </div>
  );
};

export default StatCard;
